import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Style from './Overlay.module.scss';

/**
 * Overlay Component
 * @param {Object} theme                - Theme styling from parent
 * @param {Object} backgroundClass      - optional styling for container background
 * @param {Node} children               - any additional items: button, image, text, etc.
 * @param {Function} innerContainerChildren - any additional items: button, image, text, etc.
 * @param {Boolean} rendered            - should this item render?
 * @param {Function} onClose            - click event for closing an overlay
 * @returns {Component}                 - React Component
 */
const Overlay = ({
  backgroundClass,
  backgroundUrl,
  children,
  innerContainerChildren,
  innerContainerChildrenParams,
  rendered,
  sharedTheme,
  theme,
}) => {
  if (!rendered) return null;
  const containerClasses = classNames([
    theme.container,
    sharedTheme.container,
    backgroundClass,
    Style.container,
  ]);
  const containerStyle = backgroundUrl ? { backgroundImage: `url(${backgroundUrl})` } : null;
  return (
    <div className={containerClasses} style={containerStyle}>
      <div className={theme.innerContainer}>
        {innerContainerChildren(innerContainerChildrenParams)}
        <div className={theme.content}>{children}</div>
      </div>
    </div>
  );
};

Overlay.propTypes = {
  backgroundClass: PropTypes.string,
  backgroundUrl: PropTypes.string,
  children: PropTypes.node,
  innerContainerChildren: PropTypes.func,
  innerContainerChildrenParams: PropTypes.shape({}),
  rendered: PropTypes.bool,
  sharedTheme: PropTypes.shape({}),
  theme: PropTypes.shape({}),
};

Overlay.defaultProps = {
  backgroundClass: null,
  backgroundUrl: null,
  children: null,
  innerContainerChildren: () => {},
  innerContainerChildrenParams: {},
  rendered: false,
  sharedTheme: {},
  theme: {},
};

export default Overlay;
